export const RUN_STATUS = {
  open: { label: "In progress", chip: "bg-sky-50 text-sky-700 border-sky-200" },
  fresh: { label: "Not started", chip: "bg-slate-50 text-slate-500 border-slate-200" },
  returned: { label: "Returned", chip: "bg-red-50 text-red-700 border-red-200" },
  submitted: { label: "Awaiting verification", chip: "bg-amber-50 text-amber-700 border-amber-200" },
  verified: { label: "Verified", chip: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export function runState(run) {
  if (run.status === "open") {
    if (run.rejected_note && run.progress?.done === run.progress?.total) return "returned";
    if (run.rejected_note) return "returned";
    return run.progress?.done ? "open" : "fresh";
  }
  return run.status;
}

export function categoryLabel(config, key) {
  const c = (config?.categories || []).find((x) => x.key === key);
  return c ? c.label : (key || "custom").replace(/_/g, " ");
}

export function shiftLabel(shifts, key) {
  return (shifts || []).find((s) => s.key === key)?.label || key;
}

export function fmtDay(iso) {
  if (!iso) return "";
  const d = new Date(`${iso}T12:00:00`);
  return d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short", year: "numeric" });
}

export function fmtTime(iso, tz) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", timeZone: tz || undefined });
  } catch {
    return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }
}

export function rangeText(item) {
  const lo = item.min_value, hi = item.max_value, u = item.unit || "";
  if (lo != null && hi != null) return `Safe range ${lo} – ${hi} ${u}`.trim();
  if (lo != null) return `Minimum ${lo} ${u}`.trim();
  if (hi != null) return `Maximum ${hi} ${u}`.trim();
  return "No safe range set";
}

export function outOfRange(item, v) {
  if (v === "" || v == null || Number.isNaN(Number(v))) return false;
  const n = Number(v);
  return (item.min_value != null && n < item.min_value) || (item.max_value != null && n > item.max_value);
}

export const inputCls = "w-full h-11 px-3 rounded-lg border border-slate-300 text-sm bg-white focus:outline-none focus:border-slate-900";
export const btnPrimary = "h-11 px-5 rounded-lg bg-slate-900 text-white text-sm font-bold hover:bg-slate-800 disabled:opacity-40 tap-press";
export const btnGhost = "h-11 px-4 rounded-lg border border-slate-300 bg-white text-sm font-bold text-slate-700 hover:border-slate-900 disabled:opacity-40 tap-press";
